import type { ComponentPropsWithoutRef, ElementType } from "react";

import { styled } from "simplydo/react/styled";

import { useUiColor } from "../../utils/UIContext";

type ColorProps = {
  $bg: string;
  $bgHover: string;
  $bgActive: string;
  $fg: string;
};

const StyledColored = styled.button<ColorProps>`
  background-color: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;

  &:hover,
  &:focus {
    background-color: ${({ $bgHover }) => $bgHover};
    color: ${({ $fg }) => $fg};
  }

  &:active {
    background-color: ${({ $bgActive }) => $bgActive};
  }
`;

type Props = ComponentPropsWithoutRef<"button"> & {
  as?: ElementType;
  className?: string;
};

export function ColoredButton({ as, className, ...props }: Props) {
  const uiColor = useUiColor();
  return (
    <StyledColored
      as={as}
      className={className}
      $bg={uiColor.bg}
      $bgHover={uiColor.bgHover}
      $bgActive={uiColor.bgActive}
      $fg={uiColor.fg}
      {...props}
    />
  );
}
